@if (open()) {
  <app-modal
    [config]="modalConfig"
    [title]="'features.plan.rename.title' | translate"
    (closeModal)="closeForm()">
    <app-plan-details-form
      modal-body
      [initialName]="currentName()"
      [initialDescription]="currentDescription()"
      [submitLabel]="'common.rename' | translate"
      [submitIcon]="ICONS.pencil"
      [submitting]="isSaving()"
      (submitted)="onRename($event)"
      (closeModal)="closeForm()" />
  </app-modal>
}
